import React, { useContext, useMemo, useReducer, useEffect } from 'react'
import { Box, IconButton, Tooltip } from '@mui/material'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { getSession } from '../../../contexts/auth';
import { lockedReducer } from '../../Utils/reducers';
import TableRowsIcon from '@mui/icons-material/TableRows';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import Table, { TableHook } from '../../Table';
import EditShippingAgentModal from './edit';
import { ResponsiveActionBox } from '../../Table/mobileTable';
import EditParcelsModal from './parcels';

const url = '/finimp/'

const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Deletado com sucesso')
        setState({ deleteRow: false })
        getData()
        return
    }
    console.error('Falha ao deletar')

}

const columns = (setState, permissions) => {
    return [
        {
            field: 'actions', headerName: 'Ações', filterable: false,
            renderCell: (props) => {
                return (
                    <ResponsiveActionBox >
                        {permissions.change_legacy && <Tooltip title='Parcelas'><IconButton onClick={() => { setState({ parcels: props.row }) }}><TableRowsIcon /></IconButton></Tooltip>}
                    </ResponsiveActionBox>
                )
            }
        },
        { field: 'NrContratoFin', headerName: 'Contrato', width: 100, filterType: 'string' },
        { field: 'TipoFin', headerName: 'TIPO', width: 100, filterType: 'string' },
        { field: 'NrParcelas', headerName: 'QT PARCELAS', width: 100, filterType: 'number' },
        { field: 'Prazo', headerName: 'Prazo', width: 100, filterType: 'number' },
        { field: 'DtContratacaoFin', headerName: 'DT Contrato', width: 150, filterType: 'daterangeless' },
        { field: 'Vlr', headerName: 'Valor', width: 100, filterType: 'number' },
        { field: 'TxDlrContrFin', headerName: 'Tx Dolar', width: 100, filterType: 'number' },
        { field: 'TxJrsFin', headerName: 'Tx Jrs', width: 100, filterType: 'number' },
        { field: 'Comissao', headerName: 'COMISSÃO', width: 100, filterType: 'number' },
        { field: 'IR', headerName: 'IR', width: 100, filterType: 'number' },
        { field: 'VlrIOF', headerName: 'IOF', width: 100, filterType: 'string' },
        { field: 'BcoFin', headerName: 'BANCO', width: 150, filterType: 'string' },
        { field: 'NrInstFin', headerName: 'INSTITUIÇÃO', width: 100, filterType: 'string' },
        { field: 'PcaBcoFin', headerName: 'Praça', width: 100, filterType: 'string' },
        { field: 'DtEnvDIBcoFin', headerName: 'DT ARQ FIS', width: 150, filterType: 'daterangeless' },
        { field: 'DtArqDigFin', headerName: 'DT ARQ DIG', width: 150, filterType: 'daterangeless' },
        { field: 'ObsFin', headerName: 'Observação', width: 500, filterType: 'string' },
        { field: 'ModPgto', headerName: 'Modo Pagamento', width: 200, filterType: 'number' },
        { field: 'Garantia', headerName: 'Garantia', width: 100, filterType: 'number' },

    ]
}

const Finimp = () => {

    const { setLoader } = useContext(externalComponent)

    const user = getSession()

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        parcels: null,
        editRow: null,
        deleteRow: null
    })

    const [table, reloadData] = TableHook()

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja excluir o agente marítimo ${state.deleteRow.name} - ${state.deleteRow.identifier}?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }
            {state.editRow &&
                <EditShippingAgentModal
                    data={state.editRow}
                    handleClose={() => setState({ editRow: null })}
                    reloadData={reloadData}
                />
            }
            {state.parcels &&
                <EditParcelsModal
                    data={state.parcels}
                    handleClose={() => setState({ parcels: null })}
                    reloadData={reloadData}
                />
            }

            <Box className='information-table'>
                <Box className='user-table'>
                    <Table
                        rows={state.rows}
                        columns={useMemo(() => columns(setState, user.permissions), [user.permissions])}
                        pagination
                        density='compact'
                        slots={{
                            returnComponent: ()=> window.backtobase(),
                           // addComponent: () => user.permissions.add_shippingagent ? setState({ editRow: {} }) : null,
                            filterComponent: true,
                            columnComponent: true
                        }}
                        toolbar
                        getURL={url}
                        updateRows={(rows) => setState({ 'rows': rows })}
                        innerRef={table}
                        getRowId={e => e.OID}
                    />
                </Box>
            </Box>
        </>
    )
}

export default Finimp;